export const getDealerDisplayName = (
  dealer: Record<string, any>,
  useFullName = true,
): string => {
  if (useFullName) {
    return dealer.name || dealer.site_title || '';
  }

  return dealer.abbreviation || dealer.name || dealer.site_title || '';
};

export const filterDealersBySearch = (
  dealers: Record<string, any>[],
  searchTerm: string,
  useFullName = true,
): Record<string, any>[] => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) {
    return dealers;
  }

  return dealers.filter(dealer => {
    const searchableValues = [
      getDealerDisplayName(dealer, useFullName),
      dealer.name,
      dealer.abbreviation,
      dealer.site_title,
    ]
      .filter(Boolean)
      .map(value => String(value).toLowerCase());

    return searchableValues.some(value => value.includes(term));
  });
};
